import axios from 'axios';

// Create axios instance
const apiClient = axios.create({
  baseURL: '', // Leave empty to use relative paths, triggering the proxy
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- TDC API Endpoints ---

/**
 * Fetches the TDC QR code.
 * @returns {Promise<Object>}
 */
export const getTdcQrCode = () => {
  return apiClient.get('/tdc/getQrCode');
};


/**
 * Get TDC VP
 * @returns {Promise<Object>}
 */
export const getTdcVp = () => {
  return apiClient.get('/tdc/getVp');
};

/**
 * Get TDC Status
 * @param {string} requestId
 * @returns {Promise<Object>}
 */
export const getTdcStatus = (requestId) => {
  return apiClient.get('/tdc/getStatus', {
    params: { requestId }
  });
};
